export enum ToDoStatus {
	TO_DO = "TO_DO",
	IN_PROGRESS = "IN_PROGRESS",
	QA = "QA",
	DONE = "DONE",
}
